// Caspos TapXPhone (bank terminalı) kart çəkilişi — 2 addımlı:
//   1) aç (transactionTapXPhone op0) → terminal açılır, müştəri kartı yaxınlaşdırır
//   2) yoxla (transactionTapXphoneCheck, eyni documentUUID) → dinamik backoff ilə rrn gələnə qədər
// Uğur: rrn qaytarılır. Uğursuz/imtina/timeout → xəta (satış edilmir). Cihaza sorğu C# host (fiscalForward) ilə gedir.
import api from '../api/axios';
import { fiscalForward } from './printService';

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
const newDocUUID = () => `P${Date.now()}${Math.floor(Math.random() * 1000)}`;

// Caspos check cavabı: uğur (rrn), gözləmə (pending), imtina (declined)
const parseTapxCheck = (raw) => {
    let d = null;
    try { d = typeof raw === 'string' ? JSON.parse(raw) : raw; } catch { d = null; }
    if (!d) return { pending: true };
    const node = d.data && typeof d.data === 'object' ? d.data : d;
    const rrn = node.rrn || node.RRN || d.rrn || '';
    const status = String(node.status || d.status || '').toLowerCase();
    const msg = node.message || d.message || node.msg || d.msg || '';
    if (rrn) return { rrn: String(rrn) };
    if (/declin|reject|fail|error|insufficient|imtina|cancel/i.test(`${status} ${msg}`)) {
        return { declined: true, msg: msg || 'Kart imtina edildi.' };
    }
    return { pending: true };
};

// Ortaq axın: prepare(action, payload) → {relay} qaytarır. aç → yoxla(backoff) → rrn.
const runTapxFlow = async (prepare, amount, onProgress) => {
    const documentUUID = newDocUUID();
    onProgress && onProgress('TapXPhone açılır — müştəri kartı yaxınlaşdırsın...');
    const payPrep = await prepare('pay', { amount, documentUUID });
    if (!payPrep?.relay) throw new Error('TapXPhone sorğusu hazırlanmadı.');
    await fiscalForward(payPrep.relay); // terminal açılır

    let delay = 150;
    for (let i = 0; i < 40; i++) {
        await sleep(delay);
        delay = Math.min(1500, Math.round(delay * 1.5));
        onProgress && onProgress('Kartı yaxınlaşdırın — cavab gözlənilir...');
        let fwd;
        try {
            const chk = await prepare('check', { documentUUID });
            fwd = await fiscalForward(chk.relay);
        } catch { continue; }
        const r = parseTapxCheck(fwd.raw);
        if (r.rrn) return { rrn: r.rrn, documentUUID };
        if (r.declined) throw new Error(r.msg || 'Kart imtina edildi / balans çatmır.');
    }
    throw new Error('TapXPhone cavab vermədi (vaxt bitdi).');
};

// Sifariş (menyu satış) üçün TapXPhone kart çəkilişi
export async function tapxCardCharge(orderId, amount, onProgress) {
    return runTapxFlow(
        (action, p) => api.post(`/orders/${orderId}/tapx-prepare`, { action, ...p }).then((r) => r.data),
        amount, onProgress
    );
}

// Generic kart çəkmə (Satış, Evlər, Nağd→kart və s.) — SmartOne 1-addım VƏ YA Caspos TapXPhone 2-addım.
// Uğurda {ok:true, tapx_rrn} qaytarır; uğursuzda xəta atır (çağıran dayandırır).
export async function posCardCharge(amount, label, onProgress, chargeUrl = '/cashbox/pos-charge-prepare') {
    let prep = await api.post(chargeUrl, { amount, label });
    let tapx_rrn = '';
    if (prep.data?.tapx_required) {
        const res = await runTapxFlow(
            (action, p) => api.post('/cashbox/tapx-prepare', { action, ...p }).then((r) => r.data),
            prep.data.tapx_amount || amount, onProgress
        );
        tapx_rrn = res.rrn;
        onProgress && onProgress('Kart qəbul edildi. Fiskal satış göndərilir...');
        prep = await api.post(chargeUrl, { amount, label, tapx_rrn });
    }
    let raw = null, status = null;
    if (prep.data?.relay) {
        const fwd = await fiscalForward(prep.data.relay); // SmartOne: kart burda çəkilir; Caspos: fiskal satış (kart artıq çəkilib)
        raw = fwd?.raw; status = fwd?.status;
    }
    return { ok: true, tapx_rrn, raw, status };
}
